export default __webpack_public_path__ + "static/media/delivery-parcel.1387f406.svg";